export const rubrosHistoricosactual = [
    {
        "anio" : "2025",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../../Transparencia/zip/2025/primer_trimestre2025.zip"
            },{
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/zip/2025/segundo_trimestre2025.zip"
            },{
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/zip/2025/tercer_trimestre2025.zip"
            }
        ]
    }
]